import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.for-each";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { searchgame, searchplatform, searchchannel, searchpkg } from "@/api/dataAll/dataAll";
import { getadvLocation } from "@/api/dataAll/advLocation";
import addWayConfig from "./components/addWayConfig";
import { allChannel } from "@/api/aymentsdk/getchancllist";
import { gatewayList, resetsecret, delgateway } from "@/api/aymentsdk/aymentsdk";
export default {
  name: "gateWayConfig",
  components: {
    addWayConfig: addWayConfig
  },
  data: function data() {
    return {
      visible: false,
      showing: false,
      searchgames: [],
      searchplatforms: [],
      searchchannels: [],
      searchpkgs: [],
      advchannels: [],
      value1: "",
      value2: [],
      searchData: {
        game: "",
        platform: "",
        channel: "",
        pkg: "",
        advChannel: ""
      },
      searchMark: {},
      tableData: [],
      addWayConfig: false,
      total: 0,
      page: 1,
      show: false
    };
  },
  created: function created() {
    var _this = this;

    searchgame().then(function (res) {
      _this.searchgames = res.data;
    });
  },
  methods: {
    getAllChannel: function getAllChannel() {
      var _this2 = this;

      allChannel().then(function (res) {
        _this2.advchannels = res.data;
      });
    },
    callback: function callback(a) {
      this.$alert("<strong>\u652F\u4ED8\u5BC6\u94A5ID:<i>".concat(a.pay_id, "</i></strong></br><strong>\u652F\u4ED8\u5BC6\u94A5key:<i>").concat(a.pay_key, "</i></strong>"), {
        dangerouslyUseHTMLString: true
      });
    },
    loginid: function loginid(a) {// this.$alert(
      //   `<strong>登录密钥ID:<i>${a.login_id}</i></strong></br><strong>登录密钥key:<i>${a.login_key}</i></strong>`,
      //   {
      //     dangerouslyUseHTMLString: true,
      //   }
      // );
    },
    handleJoinPeople: function handleJoinPeople(a) {
      var _this3 = this;

      var tid = {
        id: a.id
      };
      this.$alert("<strong>\u5BC6\u94A5ID:<i>".concat(a.secret_key_id, "</i></strong></br><strong>\u5BC6\u94A5key:<i>").concat(a.secret_key_key, "</i></strong>"), {
        dangerouslyUseHTMLString: true,
        confirmButtonText: "重置密钥"
      }).then(function () {
        resetsecret(tid).then(function (res) {
          _this3.$message({
            type: "success",
            message: res.message
          });

          _this3.searchClick();
        }).catch(function () {});
      });
    },
    gamechange: function gamechange(id) {
      var _this4 = this;

      if (id != "") {
        searchplatform({
          game_id: id
        }).then(function (res) {
          _this4.searchplatforms = res.data;
          _this4.searchData.platform = "";
          _this4.searchData.channel = "";
          _this4.searchData.pkg = "";
          _this4.searchMark.platform = "";
          _this4.searchMark.channel = "";
          _this4.searchMark.pkg = "";
          _this4.searchData.advChannel = "";
          _this4.searchData.advLocation = "";
          _this4.searchMark.ad_placement = "";
          _this4.searchMark.ad_channel = "";
          _this4.searchchannels = [];
          _this4.advchannels = [];
          _this4.advLocation = [];
          _this4.searchpkgs = [];

          _this4.searchgames.forEach(function (item) {
            if (item.id == id) {
              _this4.searchMark.game = item.game_mark;
            }
          });
        });
      } else {
        this.searchData.platform = "";
        this.searchData.channel = "";
        this.searchData.pkg = "";
        this.searchMark.pkg = "";
        this.searchMark.platform = "";
        this.searchMark.channel = "";
        this.searchplatforms = [];
        this.searchchannels = [];
        this.searchpkgs = [];
        this.searchMark.game = "";
        this.searchData.advChannel = "";
        this.searchData.advLocation = "";
        this.searchMark.ad_channel = "";
        this.searchMark.ad_placement = "";
        this.advchannels = [];
        this.advLocation = [];
      }
    },
    platformchange: function platformchange(id) {
      var _this5 = this;

      if (id != "") {
        searchchannel({
          platform_id: id
        }).then(function (res) {
          _this5.searchchannels = res.data.channel; // this.advchannels = res.data.adv_platform; //广告平台

          _this5.searchData.channel = "";
          _this5.searchData.pkg = "";
          _this5.searchData.advChannel = "";
          _this5.searchData.advLocation = "";
          _this5.searchMark.channel = "";
          _this5.searchMark.pkg = "";
          _this5.searchMark.ad_placement = "";
          _this5.searchMark.ad_channel = "";
          _this5.advLocation = [];
          _this5.searchpkgs = [];

          _this5.searchplatforms.forEach(function (item) {
            if (item.id == id) {
              _this5.searchMark.platform = item.platform_mark;
              _this5.searchData.channel = "";
              _this5.searchMark.channel = "";
            }
          });
        });
      } else {
        this.searchData.channel = "";
        this.searchData.pkg = "";
        this.searchMark.channel = "";
        this.searchMark.pkg = "";
        this.searchMark.platform = "";
        this.searchpkgs = [];
        this.searchchannels = [];
        this.searchData.advChannel = "";
        this.searchData.advLocation = "";
        this.searchMark.ad_placement = "";
        this.searchMark.ad_channel = "";
        this.advchannels = [];
        this.advLocation = [];
      }
    },
    channelchange: function channelchange(id) {
      var _this6 = this;

      if (id != "") {
        searchpkg({
          channel_id: id
        }).then(function (res) {
          _this6.searchpkgs = res.data;

          _this6.searchchannels.forEach(function (item) {
            if (item.id == id) {
              _this6.searchMark.channel = item.channel_mark;
              _this6.searchData.pkg = "";
              _this6.searchMark.pkg = "";
            }
          });
        });
      } else {
        this.searchData.pkg = "";
        this.searchMark.pkg = "";
        this.searchMark.channel = "";
        this.searchData.channel = "";
        this.searchpkgs = [];
      }
    },
    pkgchange: function pkgchange(id) {
      var _this7 = this;

      this.getAllChannel();

      if (id != "") {
        this.searchpkgs.forEach(function (item) {
          if (item.id == id) {
            _this7.searchMark.pkg = item.pkg_mark;
          }
        });
      } else {
        this.searchMark.pkg = "";
      }
    },
    advChannelchange: function advChannelchange(id) {
      var _this8 = this;

      if (id != "") {
        getadvLocation({
          advplatform_id: id
        }).then(function (res) {
          _this8.advLocation = res.data;
          _this8.searchMark.ad_channel = "";

          _this8.advchannels.forEach(function (item) {
            if (item.id == id) {
              _this8.searchMark.ad_channel = item.adv_platform_mark;
              _this8.searchData.advLocation = "";
              _this8.searchMark.ad_placement = "";
            }
          });
        });
      } else {
        this.searchData.advLocation = "";
        this.searchMark.ad_placement = "";
        this.searchMark.ad_channel = "";
        this.searchData.advChannel = "";
        this.advLocation = [];
      }
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.searchMark.page = val;
      this.searchClick();
    },
    searchClick: function searchClick() {
      var _this9 = this;

      gatewayList(this.searchMark).then(function (res) {
        if (res.status == 200) {
          var list = ['game', 'platform', 'channel', 'pkg', 'ad_channel', 'ad_placement'];
          _this9.tableData = res.data.data.length ? _this9.$utils.dataConversion(res.data.data, list) : [];
          _this9.total = res.data.total || 0;
          _this9.show = true;
        }
      });
    },
    handleSource: function handleSource(id, num) {
      this.$refs.addWayConfig.init(id, num);
    },
    changeShow: function changeShow(val) {
      this.showing = val;
    },
    handleDelete: function handleDelete(id) {
      var _this10 = this;

      this.$confirm("此操作将删除该网关配置, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                delgateway({
                  id: id
                }).then(function (res) {
                  _this10.searchClick();
                });

                _this10.$message({
                  type: "success",
                  message: "删除成功!"
                });

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      })));
    }
  }
};